import React, {useEffect, useState} from 'react';
import TTLAsyncProxy from "../../common/TTLAsyncProxy";
import ReactRating from "react-rating";
import NumberLabel from "../../components/NumberLabel/NumberLabel";
import {TractorOperatorEndpoint} from "../../common/ProxyEndpoints";
import MDSpinner from 'react-md-spinner';

function RatingView({ operatorId , initialAverageRating , initialTotalRating }) {

    const [rating,setRating] = useState({
        averageRating: initialAverageRating || 5,
        totalRating: initialTotalRating || 0
    });

    const [isBusy,setIsBusy] = useState(false);

    const queryRatings = async () => {

        setIsBusy(true);

        try{
            const proxy = TTLAsyncProxy.getInstance();
            const response = await proxy.processRequest(TractorOperatorEndpoint.getRatings(operatorId));
            setRating(response.getPayload());
        }
        catch (e) {

        }
        finally {
            setIsBusy(false);
        }
    };

    useEffect(() => {

        queryRatings();

    },[operatorId]);

    return <div>

        <div className="clearfix">

            <b className="pull-left">Driver/Operator Ratings</b>
            <div className="pull-right">
                {isBusy && <MDSpinner size={24}/>}
            </div>

        </div>

        <div className="m-1 text-center">
            <h4><NumberLabel value={rating.averageRating}
                             precision={1}
                             maximumFractionDigits={1}/></h4>
            <ReactRating readonly
                         emptySymbol="fa fa-star-o"
                         fullSymbol="fa fa-star"
                         fractions={2}
                         initialRating={rating.averageRating}/>

            <br/>
            <b style={{ color: "#b9b9b9"}}>{rating.totalRating}</b>
        </div>

    </div>


}

export default RatingView;


// WEBPACK FOOTER //
// ./src/views/Operators/RatingView.js